import { render, staticRenderFns } from "./AddHomeBed.vue?vue&type=template&id=190e9186&"
import script from "./AddHomeBed.vue?vue&type=script&lang=js&"
export * from "./AddHomeBed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports